import { render, staticRenderFns } from "./SignDialog.vue?vue&type=template&id=73b7bc71&scoped=true"
import script from "./SignDialog.vue?vue&type=script&lang=js"
export * from "./SignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b7bc71",
  null
  
)

export default component.exports